import client from './client';
// 사용자 퀴즈 등록
export const submitQuiz = ({ quizzes, quizState, user_id }) => {
  return client.post(`/my/account/user/${user_id}/quiz`, { quizzes });
};
